import { NavigateOptions, useNavigate } from 'react-router';

import { useLocation } from '~src/hooks/useLocation';
import { clearFrontendCache } from '~src/hooks/useCachedState';
import { replacePath } from '~src/util/string';
import { useDisplayContext } from '~src/context/DisplayContext';

export const useNavigation = () => {
  const routerNavigate = useNavigate();

  const navigate = (route: string, options?: NavigateOptions) => routerNavigate(route, options);

  const navigateBack = () => {
    routerNavigate(-1);
  };

  return { navigate, navigateBack };
};

export const useCalculatorNavigation = (source: string, clearCache = false) => {
  const { location } = useLocation() ?? {};

  const { leadOrigin } = useDisplayContext();

  const { navigate } = useNavigation();

  const { pathname } = location;

  if (!pathname || pathname === '/') {
    return (target: string) => {
      const targetWithLeadOrigin = `${leadOrigin}/${target}`;

      navigate(replacePath(location.pathname, source, targetWithLeadOrigin));
    };
  }

  if (clearCache) {
    clearFrontendCache();
  }

  return (target: string) => {
    navigate(replacePath(location.pathname, source, target));
  };
};
